import React from 'react';
import { styled } from 'styled-components';
import { HeaderHeights, MAX_WIDTH } from '../utils/header-heights';
import { Spaces } from '../utils/spaces';
import Logo from '../static/assets/ADAC-Logo.svg';
import { maxWidth, minWidth } from '../utils/media-queries';

const StyledHeader = styled.header`
  @media ${maxWidth.S} {
    position: fixed;
    width: 100%;
  }

  position: relative;
  top: 0;
  z-index: 3000;
  height: ${HeaderHeights.MAIN}px;
  background-color: rgb(255, 204, 0);
`;

const StyledHeaderContent = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: ${MAX_WIDTH};
  height: 100%;
  margin: 0 auto;
  padding: 0 ${Spaces.M};

  @media ${minWidth.S} {
    padding: ${Spaces.XXS} ${Spaces.S};
  }
`;

const StyledNavigation = styled.nav`
  @media ${maxWidth.S} {
    display: none;
  }

  position: sticky;
  height: ${HeaderHeights.NAV}px;
  background-color: rgb(255, 255, 255);
  z-index: 2000;
  top: 0;
`;

export const Header: React.FC = () => (
  <>
    <StyledHeader>
      <StyledHeaderContent>
        <a href="/">
          <img src={Logo} width="90" alt="ADAC Logo" />
        </a>
      </StyledHeaderContent>
    </StyledHeader>
    <StyledNavigation />
  </>
);
